export { default } from './LoaderBig';
